import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles/createTheme';
import { EdwardColors } from 'enums';

export default makeStyles((theme: Theme) =>
  createStyles({
    typeFailedDeposit: {
      color: EdwardColors.ALERT,
    },
    table: {
      //'& tbody tr': { visibility: 'visible !important'},
      '& tbody tr': { cursor: 'default !important' },
      //'& tbody td': { cursor: 'inherit !important' },
      '& tbody td:not(:first-child)': { color: '#000 !important' },
      '& tbody td:first-child, & tbody td:first-child button': {
        color: 'inherit !important',
      },
      '& tbody td:first-child button': {
        backgroundColor: 'rgba(0,0,0,0)',
      },
      '& td, & th': {
        boxSizing: 'border-box',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        position: 'relative'
      },
      '& table tbody td:only-child': { padding: '0 !important'}
    },
    wrapper: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      cursor: 'pointer',
      padding: 'inherit',
      justifyContent: 'inherit'
    }
  }),
);
